import { EmoticonExcitedOutlineIcon } from './EmoticonExcitedOutlineIcon';

/**
 * author: Google
 * id 828FF1EE-1B9B-4407-A45B-A071FA938158
 * name emoticon-excited-outline
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-excited-outline.svg
 * tags
 * - Emoji 
 */
export const SmileyExcitedOutlineIcon = EmoticonExcitedOutlineIcon;
export default SmileyExcitedOutlineIcon